var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"aa-about"},[_c('AboutHeading',{attrs:{"items":this.itemsHeading}}),_c('CustomersCard',{attrs:{"items":this.itemsCustomers}}),_c('OurTeamCard',{attrs:{"items":this.itemsTeam}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }